import { Inject, Injectable } from '@angular/core';
import { TBAppEnvironmentVars } from '@monorepo/types';

export const AqlEndPoint = {
  SEARCH_BCTX: '/api/v1/searchBCTX/:factoryId',
  SEARCH_BCTX_V2: '/api/v2/searchBCTX/:factoryId',
  GET_AQL_LEVEL: '/api/v2/aqllevel/listing/byFactoryId',
  ADD_AQL_LEVEL: '/api/v2/addAQLLevel/:factoryId',
  EDIT_AQL_LEVEL: '/api/v2/addUpdateAQLLevel',
  DELETE_AQL_LEVEL: '/api/v2/deleteAQLLevel',
  GET_AQL_MEASUREMENT: '/api/v3/aqluom/listing/byFactoryId',
  GET_AQL_POM: '/api/v3/aqlpom/listing/byFactoryId',
  EDIT_AQL_POM: '/api/v3/addEditPOMs',
  DELETE_AQL_POM: '/api/v3/bulk/deletePOMs',

  // DOWNLOAD_ERROR_FILE: '/api/v1/aql/download/errorSheet?key=',
  AQL_UPLOAD_ERROR_FILE: '/api/v1/aqllevel/download/errorSheet?key=',
  POM_UPLOAD_ERROR_FILE: '/api/v1/aqlpom/download/errorSheet?key=',
  DOWNLOAD_AQL_LEVEL_TEMPLATE: '/api/v1/aqllevel/template/byFactoryId',
  DOWNLOAD_AQL_LEVEL_LIST: '/api/v1/aqllevel/download_leveldetails',
  DOWNLOAD_AQL_POM_TEMPLATE: '/api/v2/aqlpom_sheet_download/listing',
  DOWNLOAD_AQL_POM: '/api/v3/aqlpom_details_download/listing',
  UPLOAD_AQL_LEVEL_EXCEL: '/api/v2/aqllevel/upload',
  UPLOAD_POM_EXCEL: '/api/v3/aqlpom/upload',

  GET_DEPARTMENTS_LIST: '/api/v1/departments/get',
};

@Injectable({ providedIn: 'root' })
export class AqlEnvProvider {
  public protocol = 'http';
  public service_host = '';
  public aql_services = '';
  #API_URL: string;

  constructor(@Inject('environment') ENV: TBAppEnvironmentVars) {
    if (ENV.protocol !== null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host !== null) {
      this.service_host = ENV.service_host;
    }

    if (ENV.core_services !== null) {
      this.aql_services = ENV.core_services;
    }
    this.#API_URL = this.protocol + this.service_host + this.aql_services;
  }

  public getUrlFromEnv(arg: keyof typeof AqlEndPoint): string {
    return this.#API_URL + AqlEndPoint[arg];
  }
}
